/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

export type Payload = {
	searchSessionId?: string;
	searchObjectId?: string;
	searchContainerId?: string;
	searchContentType?: string;
	[key: string]: unknown;
};
/**
 * Enhances a given payload with search-related attributes to facilitate tracking of search sessions. Attributes are either extracted from the payload or retrieved from metadata.
 */
export const addSearchSessionAttributes = <T extends Payload>(payload?: T | null): T => {
	const safePayload: Payload = payload || {};
	const sessionAttributes = {
		searchSessionId:
			'searchSessionId' in safePayload && safePayload.searchSessionId
				? safePayload.searchSessionId
				: getMeta('ajs-search-session-id'),
		searchObjectId:
			'searchObjectId' in safePayload && safePayload.searchObjectId
				? safePayload.searchObjectId
				: getMeta('ajs-search-object-id'),
		searchContainerId:
			'searchContainerId' in safePayload && safePayload.searchContainerId
				? safePayload.searchContainerId
				: getMeta('ajs-search-container-id'),
		searchContentType:
			'searchContentType' in safePayload && safePayload.searchContentType
				? safePayload.searchContentType
				: getMeta('ajs-search-content-type'),
	};

	// oxlint-disable-next-line typescript/consistent-type-assertions
	return {
		...payload,
		...pickBy<Payload>(sessionAttributes, identity),
	} as T;
};
